export default "__VITE_PUBLIC_ASSET__4be24046__"